import type { User as IUser } from '@baseball-near-you/prisma';
import { toast } from '@baseball-near-you/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clients } from '../clients';
import { QueryKey } from '../hooks/QueryKey';

export function useUpdateUserMutation(args?: { showToast?: boolean }) {
  const { showToast = true } = args ?? {};
  const queryClient = useQueryClient();
  const {
    mutateAsync: updateUser,
    isLoading: updatingUser,
    error: userError,
  } = useMutation({
    mutationFn: (user: Partial<IUser> & { id: string }) => {
      return clients.user.update({ args: { id: user.id }, payload: user });
    },
    onSuccess: async (u) => {
      await queryClient.invalidateQueries([QueryKey.User]);
      if (showToast) {
        toast.success('Profile updated', {
          description: 'Your profile has been updated successfully',
        });
      }
    },
    onError: (error: { message?: string }) => {
      toast.error('There was an error updating your profile.', {
        description: error?.message ?? 'Please try again later',
      });
    },
  });
  return {
    updateUser,
    updatingUser,
    userError,
  };
}
